import * as React from "react";
import { SVGProps } from "react";
const SvgUserOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M25 17c0-2.2-1.8-4-4-4H11c-2.2 0-4 1.8-4 4v10c0 .6.4 1 1 1s1-.4 1-1V17c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v10c0 .6.4 1 1 1s1-.4 1-1V17Zm-9-8c1.395 0 2.5-1.105 2.5-2.5S17.395 4 16 4a2.481 2.481 0 0 0-2.5 2.5C13.5 7.895 14.605 9 16 9Zm0 2c-2.5 0-4.5-2-4.5-4.5S13.5 2 16 2s4.5 2 4.5 4.5-2 4.5-4.5 4.5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserOutline;
